export default "__VITE_ASSET__2969cf4b__"